"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAddressV2Url = exports.fetchStatesMetadataApiUrl = exports.fetchCountriesMetadataApiUrl = exports.payPalContactPaymentDetailsUrl = exports.updatePayPalOrderUrl = exports.createPayPalOrderUrl = exports.applePayValidateMerchantUrl = exports.expressPaymentMethodsUrl = exports.paymentMethodsBannerSettingsApiUrl = exports.expressCheckoutWidgetSettingsApiUrl = exports.widgetSettingsApiUrl = exports.paymentMethodsBuyNowPayLaterApiUrl = exports.paymentMethodsOrderApiUrl = exports.paymentMethodsAccountApiUrl = exports.paymentMethodsApiUrl = exports.paymentMethodOrderApiUrl = exports.paymentMethodAccountApiUrl = exports.accountUrl = exports.chargeUrl = exports.orderChargesUrl = exports.chargesUrl = exports.createContactAndUpdateOrderUrl = exports.buyerInfoUrl = exports.ordersUrl = exports.subscriptionUrl = exports.mandatoryFieldsProviderUrl = exports.mandatoryFieldsUrl = exports.resolveCountryUrl = exports.orderUrl = exports.agreementIdByOrderIdUrl = exports.orderSetupUrl = exports.tokenForSavedCard = exports.tokenizeCardUrl = exports.creditCardUrl = exports.creditCardsUrl = exports.publicCreditCardPrimaryUrl = exports.publicCreditCardUrl = exports.publicCreditCardsUrl = exports.paymentDetailsUrl = exports.pciOrigin = exports.oldPciOrigin = void 0;
var validateGUID_1 = require("@wix/cashier-common/dist/src/utils/guid/validateGUID");
var servicesPrefixV1 = '/_api/payment-services-web';
var servicesPrefixV2 = '/_api/payment-services-web/v2';
var servicesPaymentsPrefix = '/_api/payment-services-web/payments/v2';
var metadataPrefixV2 = '/_api/cashier-metadata/v2';
var gatewayPrefix = '/_api/payment-gateway-web';
var settingsServerPrefix = '/_api/cashier-settings-server';
var paymentsCheckoutServerPrefix = '/_serverless/payments-checkout-server';
exports.oldPciOrigin = "https://cashier.wix.com";
exports.pciOrigin = "https://cashier-pci.wixapps.net";
var paymentDetailsUrl = function () { return "".concat(servicesPaymentsPrefix, "/payment-details"); };
exports.paymentDetailsUrl = paymentDetailsUrl;
var publicCreditCardsUrl = function () { return "".concat(servicesPrefixV2, "/credit-cards"); };
exports.publicCreditCardsUrl = publicCreditCardsUrl;
var publicCreditCardUrl = function (creditCardId) { return "".concat(servicesPrefixV2, "/credit-cards/").concat(creditCardId); };
exports.publicCreditCardUrl = publicCreditCardUrl;
var publicCreditCardPrimaryUrl = function (creditCardId) {
    return "".concat(servicesPrefixV2, "/credit-cards/").concat(creditCardId, "/primary");
};
exports.publicCreditCardPrimaryUrl = publicCreditCardPrimaryUrl;
var creditCardsUrl = function () { return "".concat(gatewayPrefix, "/v2/credit-cards"); };
exports.creditCardsUrl = creditCardsUrl;
var creditCardUrl = function (creditCardId) { return "".concat(gatewayPrefix, "/v2/credit-cards/").concat(creditCardId); };
exports.creditCardUrl = creditCardUrl;
var tokenizeCardUrl = function () { return "".concat(gatewayPrefix, "/tokenize/v2/tokens"); };
exports.tokenizeCardUrl = tokenizeCardUrl;
var tokenForSavedCard = function (creditCardId) { return "".concat(gatewayPrefix, "/v2/credit-cards/").concat(creditCardId, "/tokens"); };
exports.tokenForSavedCard = tokenForSavedCard;
var orderSetupUrl = function () { return "".concat(servicesPaymentsPrefix, "/orders/setup"); };
exports.orderSetupUrl = orderSetupUrl;
var agreementIdByOrderIdUrl = function (orderId) { return "".concat(servicesPaymentsPrefix, "/orders/").concat(orderId, "/agreement"); };
exports.agreementIdByOrderIdUrl = agreementIdByOrderIdUrl;
var orderUrl = function (orderId) { return "".concat(servicesPaymentsPrefix, "/orders/").concat(orderId); };
exports.orderUrl = orderUrl;
var resolveCountryUrl = function () { return "".concat(servicesPrefixV1, "/buyer/country"); };
exports.resolveCountryUrl = resolveCountryUrl;
var mandatoryFieldsUrl = function (orderId) { return "".concat(servicesPaymentsPrefix, "/orders/").concat(orderId, "/mandatory-fields"); };
exports.mandatoryFieldsUrl = mandatoryFieldsUrl;
var mandatoryFieldsProviderUrl = function () { return "".concat(servicesPaymentsPrefix, "/mandatory-fields"); };
exports.mandatoryFieldsProviderUrl = mandatoryFieldsProviderUrl;
var subscriptionUrl = function (orderId) { return "".concat(servicesPaymentsPrefix, "/orders/").concat(orderId, "/subscription"); };
exports.subscriptionUrl = subscriptionUrl;
var ordersUrl = function () { return "".concat(servicesPaymentsPrefix, "/orders"); };
exports.ordersUrl = ordersUrl;
var buyerInfoUrl = function (orderId) { return "".concat(servicesPaymentsPrefix, "/orders/").concat(orderId, "/buyer-info"); };
exports.buyerInfoUrl = buyerInfoUrl;
var createContactAndUpdateOrderUrl = function () { return "/_api/payment-notifier-web/pay-app/v1/buyer-info"; };
exports.createContactAndUpdateOrderUrl = createContactAndUpdateOrderUrl;
// TODO: Need to remove `accountId` from URL
var chargesUrl = function (accountId) { return "".concat(servicesPaymentsPrefix, "/accounts/").concat(accountId, "/charges"); };
exports.chargesUrl = chargesUrl;
var orderChargesUrl = function (orderId) { return "".concat(servicesPaymentsPrefix, "/orders/").concat(orderId, "/charges"); };
exports.orderChargesUrl = orderChargesUrl;
var chargeUrl = function (chargeId) { return "".concat(servicesPaymentsPrefix, "/charges/").concat(chargeId); };
exports.chargeUrl = chargeUrl;
var accountUrl = function (accountId) { return "".concat(paymentsCheckoutServerPrefix, "/account/").concat(accountId); };
exports.accountUrl = accountUrl;
var paymentMethodAccountApiUrl = function (accountId, paymentMethod) {
    return "".concat(servicesPaymentsPrefix, "/accounts/").concat(accountId, "/payment-methods/").concat(paymentMethod);
};
exports.paymentMethodAccountApiUrl = paymentMethodAccountApiUrl;
var paymentMethodOrderApiUrl = function (orderId, paymentMethod) {
    return "".concat(servicesPaymentsPrefix, "/orders/").concat(orderId, "/payment-methods/").concat(paymentMethod);
};
exports.paymentMethodOrderApiUrl = paymentMethodOrderApiUrl;
var paymentMethodsApiUrl = function () { return "".concat(servicesPaymentsPrefix, "/payment-methods"); };
exports.paymentMethodsApiUrl = paymentMethodsApiUrl;
var paymentMethodsAccountApiUrl = function (accountId) {
    return "".concat(servicesPaymentsPrefix, "/accounts/").concat(accountId, "/payment-methods");
};
exports.paymentMethodsAccountApiUrl = paymentMethodsAccountApiUrl;
var paymentMethodsOrderApiUrl = function (orderId) {
    return "".concat(servicesPaymentsPrefix, "/orders/").concat(orderId, "/payment-methods");
};
exports.paymentMethodsOrderApiUrl = paymentMethodsOrderApiUrl;
var paymentMethodsBuyNowPayLaterApiUrl = function (accountId) {
    return "".concat(servicesPaymentsPrefix, "/accounts/").concat(accountId, "/bnpl/payment-methods");
};
exports.paymentMethodsBuyNowPayLaterApiUrl = paymentMethodsBuyNowPayLaterApiUrl;
var getSettingsServerPrefix = function (useNewApi) {
    return useNewApi ? paymentsCheckoutServerPrefix : settingsServerPrefix;
};
var widgetSettingsApiUrl = function (params) {
    return "".concat(paymentsCheckoutServerPrefix, "/widget-settings") + ((0, validateGUID_1.validateGUID)(params === null || params === void 0 ? void 0 : params.msid) ? "?msid=".concat(params.msid) : '');
};
exports.widgetSettingsApiUrl = widgetSettingsApiUrl;
var expressCheckoutWidgetSettingsApiUrl = function (useNewApi) {
    if (useNewApi === void 0) { useNewApi = false; }
    return "".concat(getSettingsServerPrefix(useNewApi), "/express-checkout-widget-settings");
};
exports.expressCheckoutWidgetSettingsApiUrl = expressCheckoutWidgetSettingsApiUrl;
var paymentMethodsBannerSettingsApiUrl = function (useNewApi) {
    if (useNewApi === void 0) { useNewApi = false; }
    return "".concat(getSettingsServerPrefix(useNewApi), "/payment-methods-banner-settings");
};
exports.paymentMethodsBannerSettingsApiUrl = paymentMethodsBannerSettingsApiUrl;
var expressPaymentMethodsUrl = function (accountId) {
    return "".concat(servicesPaymentsPrefix, "/accounts/").concat(accountId, "/express-payment-methods");
};
exports.expressPaymentMethodsUrl = expressPaymentMethodsUrl;
var applePayValidateMerchantUrl = function (accountId) {
    return "".concat(servicesPaymentsPrefix, "/accounts/").concat(accountId, "/apple-pay-validate-merchant");
};
exports.applePayValidateMerchantUrl = applePayValidateMerchantUrl;
var createPayPalOrderUrl = function (accountId) { return "".concat(servicesPaymentsPrefix, "/accounts/").concat(accountId, "/paypal-checkout"); };
exports.createPayPalOrderUrl = createPayPalOrderUrl;
var updatePayPalOrderUrl = function (accountId, orderId) {
    return "".concat(servicesPaymentsPrefix, "/accounts/").concat(accountId, "/paypal-checkout/").concat(orderId);
};
exports.updatePayPalOrderUrl = updatePayPalOrderUrl;
var payPalContactPaymentDetailsUrl = function (accountId, orderId) {
    return "".concat(servicesPaymentsPrefix, "/accounts/").concat(accountId, "/paypal-checkout/").concat(orderId, "/payment-details");
};
exports.payPalContactPaymentDetailsUrl = payPalContactPaymentDetailsUrl;
var fetchCountriesMetadataApiUrl = function () { return "".concat(metadataPrefixV2, "/locales/countries"); };
exports.fetchCountriesMetadataApiUrl = fetchCountriesMetadataApiUrl;
var fetchStatesMetadataApiUrl = function () { return "".concat(metadataPrefixV2, "/locales/states"); };
exports.fetchStatesMetadataApiUrl = fetchStatesMetadataApiUrl;
var fetchAddressV2Url = function () { return "".concat(metadataPrefixV2, "/address"); };
exports.fetchAddressV2Url = fetchAddressV2Url;
//# sourceMappingURL=apiRoutes.js.map